export class ArrayUtils {
    public static getLickertScaleUpTo(max: number): Array<number> {
        return [...Array(max)].map((_, index) => index + 1);
    }

    /**
     * Creates an array of indices from 0 to length-1
     * @param length - The length of the array to create
     * @returns Array of indices [0, 1, 2, ..., length-1]
     * @example ArrayUtils.range(3) // [0, 1, 2]
     */
    public static range(length: number): number[] {
        return Array.from({ length }, (_, i) => i);
    }
}